import {QbElement} from "./qb-element.js"

class QbCode extends QbElement {
    static observedAttributes = ["size", "value", "action", "disabled", "pattern"]
    static shadow = {mode: 'open', sheets: ["qb-elements"]}

    get init() {
       const name = this.getAttribute("name");
       if(name) this.innerHTML = `<input type="hidden" name="${name}"/>`;
    }

    #action = "/token"
    get action() {
        return this.#action;
    }

    set action(value) {
        this.#action = value;
    }

    $action(value) {
        this.#action = value;
    }


    get #inputNode() {
       return this.firstElementChild;
    }


    #pattern = "[a-zA-Z0-9]+"

    $pattern(value) {
        [...this.contentRoot.children].forEach(n => n.pattern = value);
        this.#pattern = value;
    }


    get value() { return this.#inputNode.value }

    set disabled(value) {
        [...this.children].forEach(n => n.disabled = value);
        this.#inputNode.disabled = value;
    }

    focus() {
        if(this.matches(':focus-within')) return;
        this.contentRoot.firstElementChild.focus();
    }

    $size(value) {
        const fields = []
        for(let i = 0; i < value; i++) fields.push(
            cT('input type="text" autocomplete="off" required="" maxLength="1" size="1"', {
                pattern: this.#pattern,
                name: "token[]",
                events: [this, "input", "beforeinput"]
            })
        );
        const form = cT("form", {method: "post", action: this.action},
                cT('input type="hidden" name="authenticity_token"', {value: document.metas.csrfToken}),
                fields,
                cT('button type="submit" class="nobutton"', cT('i-submit'))
            )
        ;
        this.contentRoot.replaceChildren(form);
    }
    get inputs() {
        return [...this.contentRoot.querySelectorAll('[name="token[]"]')];
    }

    handleEvent_beforeinput(evt) {
        if(evt.inputType === 'insertFromPaste') {
            evt.preventDefault();
            const code = evt.data.replace(/[^A-Za-z0-9]/, "");
            this.inputs.forEach((n, i) => n.value = code[i] || "");
            const form = this.contentRoot.firstElementChild;
            if(this.hasChildNodes) return this.#inputNode.value = this.inputs.map(n => n.value).join("");
            if(form.checkValidity()) form.submit();
            else this.contentRoot.querySelector("button").focus();
            return;
        }
        if(evt.inputType === 'deleteContentBackward' && !evt.currentTarget.value) {
            evt.currentTarget.previousElementSibling?.focus();
        }

        evt.currentTarget.value = '';
    }

    handleEvent_input(evt) {
        this.#inputNode.value = this.inputs.map(n => n.value).join("");
        if(evt.inputType === 'deleteContentBackward') return;
        let next = evt.currentTarget.nextElementSibling;
        if(next) next.focus();
        else evt.currentTarget.blur();
    }
}

QbCode.register;